import { render } from "./CincoEstrellasFeedbackNew.vue?vue&type=template&id=46fd8347&scoped=true"
import script from "./CincoEstrellasFeedbackNew.vue?vue&type=script&lang=js"
export * from "./CincoEstrellasFeedbackNew.vue?vue&type=script&lang=js"

import "./CincoEstrellasFeedbackNew.vue?vue&type=style&index=0&id=46fd8347&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fd8347"]])

export default __exports__